import { Routes } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';

export const CONTENT_ROUTES: Routes = [
    {
        path: 'pages',
        loadChildren: () => import('../../pages/content-pages/content-pages.module').then(m => m.ContentPagesModule)

    },
    {
        path: 'auth',
        loadChildren: () => import('../../auth/auth.module').then(m => m.AuthModule),
        canActivate: [AuthGuard]
    }
];
